/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO: Remove this disable and fix all any types in this file
import { initMatomo } from "@certible/use-matomo";

export const useAnalytics = () => {
    const initialize = (app: any) => {
        const analyticsSystems = (document.getElementById("analytics_systems") as HTMLInputElement)?.value;

        if (analyticsSystems?.startsWith("[") && analyticsSystems.endsWith("]")) {
            //HTML encodes the content, so we need to replace the encoded characters
            const decodedAnalyticsSystems = analyticsSystems.replace(/&quot;/g, '"').replace(/&amp;/g, "&");
            const analytics: [{ apiToken: string; host: string; siteId: string; type: string }] =
                JSON.parse(decodedAnalyticsSystems);

            const matomoConfig = analytics.find((analytic) => analytic.type === "MATOMO");
            if (matomoConfig) {
                const matomo = initMatomo({
                    host: matomoConfig.host,
                    siteId: matomoConfig.siteId,
                    trackRouter: true,
                    disableCookies: true,
                });
                app.use(matomo);
            }
        }
    };

    return { initialize };
};
